/* import __COLOCATED_TEMPLATE__ from './reporting-tab.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();